import type { ReaderName } from "@bindery/shared/contracts/session";
import { Button } from "@bindery/ui/components/ui/button";
import { Link } from "react-router";
import { SignedIn } from "../chrome/signed-in";
import { Workbench } from "../chrome/workbench";
import { ReaderPicker } from "../components/reader-picker";
import { WorksheetList } from "../components/worksheet-list";
import { useBoundReader } from "../data/use-bound-reader";
import { useReaderRoster } from "../data/use-reader-roster";
import { useWorksheets } from "../data/use-worksheets";
import { ROUTES } from "../routes";
import { readerDisplayName } from "../lib/reader-name";

function ReaderWorksheets({ reader }: { reader: ReaderName }) {
  const worksheets = useWorksheets(reader.readerId);
  return (
    <section className="flex flex-col gap-4">
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <h2 className="font-serif text-2xl font-semibold">
          {readerDisplayName(reader)}’s worksheets
        </h2>
        <Button asChild>
          <Link to={ROUTES.create}>Make a worksheet</Link>
        </Button>
      </div>
      <WorksheetList
        worksheets={worksheets}
        readerNickname={readerDisplayName(reader)}
      />
    </section>
  );
}

function HomeContent() {
  const readers = useReaderRoster();
  const { boundReader, bindReader } = useBoundReader();
  return (
    <div className="flex flex-col gap-10">
      <section className="flex flex-col gap-4">
        <h1 className="font-serif text-3xl font-semibold tracking-tight">
          {boundReader === null ? "Who is this worksheet for?" : "Reader"}
        </h1>
        <ReaderPicker
          readers={readers}
          boundReaderId={boundReader?.readerId ?? null}
          onPick={(readerId) => bindReader(readerId, ROUTES.home)}
        />
      </section>
      {boundReader === null ? null : <ReaderWorksheets reader={boundReader} />}
    </div>
  );
}

export function HomePage() {
  return (
    <Workbench>
      <SignedIn returnTo={ROUTES.home}>{() => <HomeContent />}</SignedIn>
    </Workbench>
  );
}
